import React from 'react';
import { faClose } from '@fortawesome/pro-solid-svg-icons';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NSButton } from 'bricks/NSButton/NSButton';
import './NSContactChip.scss';

interface INSContactChipProps {
    name: string;
    onRemove: () => void;
}

const NSContactChip: React.FC<INSContactChipProps> = ({ name, onRemove }) => (
    <div
        className="NSContactChip border border-primary bg-primary-lighten font-12 p-2 d-inline-flex align-items-center gap-1"
        aria-label={`Contact chip for ${name}`}
    >
        <FontAwesomeIcon className="text-primary mr-1" icon={faUser} size="sm" />
        <span className="text-primary mr-1">{name}</span>
        <NSButton
            className="text-primary p-0"
            callback={onRemove}
            aria-label={`Remove ${name}`}
            icon={faClose}
        />
    </div>
);

export default NSContactChip;
